<a class="w-100 d-flex justify-content-between pb-2 mb-2 px-2 align-items-center border-bottom" (click)="navigatorTo()">
  <div class="d-flex">
    <i class="fs-5 bi bi-journal-text fw-semibold me-2"></i>
    <div>
      <div class="fw-bold">{{ title }}</div>
      <span class="text-gray-700">The full description of {{ title.toLocaleLowerCase() }} comes here.</span>
    </div>
  </div>
  <span class="btn btn-light btn-lg"> <i class="bi bi-box-arrow-up-right fw-bold me-2"></i> View Report</span>
</a>
